import { Controller } from 'stimulus'

// A wrapping row of chips that grow on hover. Saved-view pills show their
// star and ... menu only on hover, with no room kept for them. A pill at the
// end of a line has nowhere to grow: it would wrap to the next line, out from
// under the pointer, and shrink back before its menu could be reached. While
// such a pill is hovered, a negative right margin as wide as its growth keeps
// its place in the row unchanged, and it grows into the row's end gutter
// (padding-right on the row). Pills mid-line grow and push their neighbours
// as before.
//
//   data-controller="chip-row" data-chip-row-chip=".view-pill"
//   data-action="mouseover->chip-row#hold mouseout->chip-row#release"
//
// The chip's hover rules skip `.chip-at-rest`, which is how its size at rest
// is measured.
export default class extends Controller {
  hold(event) {
    const chip = event.target.closest(this.data.get('chip'))
    if (!chip || chip === this.held || !this.element.contains(chip)) return

    this.held = chip
    chip.style.marginRight = ''
    chip.classList.add('chip-at-rest')
    const restTop = chip.offsetTop
    const restWidth = chip.getBoundingClientRect().width
    chip.classList.remove('chip-at-rest')
    if (chip.offsetTop === restTop) return

    const growth = chip.getBoundingClientRect().width - restWidth
    const margin = parseFloat(getComputedStyle(chip).marginRight) || 0
    chip.style.marginRight = `${margin - growth}px`
  }

  release(event) {
    const chip = this.held
    if (!chip || chip.contains(event.relatedTarget)) return

    chip.style.marginRight = ''
    this.held = null
  }
}
